import Accordion from './Accordion';
//import { sendGoogle } from './Analytics';
import { BREAKPOINTS } from './ApplicationConfig';
import ApplicationState from './ApplicationState';
import DelayedCall from './DelayedCall';
import DOMElementNotFoundError from './error/DOMElementNotFoundError';
import { formDataToQueryString } from './form/QueryString';
import UserInputValidator from './form/UserInputValidator';
import LazyLoad from './lazy-load/LazyLoad';
import PopupController from './popup/PopupController';
//import addResizeHandler from './ResizeEventListener';
import StyledSelect from './StyledSelect';
import { getParentByClass } from './Utils';
import Tabs from './Tabs';
import axios from 'axios';

const xhr = ApplicationState.axios;

export default class Filter
{
    protected wrapper: HTMLElement;
    protected form: HTMLFormElement;
    protected brands: NodeListOf<HTMLInputElement>;
    protected selectedBrands: HTMLElement;
    protected selectAllBrandsButton: NodeListOf<HTMLInputElement>;
    protected showAllBrandsButton: NodeListOf<HTMLInputElement>;
    protected expandFilterButton: HTMLElement;
    protected delayedCall: DelayedCall;
    protected prefilterCancelToken: any = null;
    protected tabs: Tabs;
    protected accordion: Accordion;
    protected isTabLoading: boolean = false;
    protected styledSelect: StyledSelect;
    protected hint: PopupController;
    protected popularBrands: HTMLElement;
    protected allBrands: HTMLElement;

    protected classes = {
        formExtended: 'filter__form_extend',
        formExpanded: 'filter__body_expanded',
        option: 'filter__option',
        optionExtend: 'filter__option_extend',
        extendButton: 'js-extend-filter',
        selectAllBrands: 'js-select-all-brands',
        selectAllBrandsSidebar: 'js-select-all-brands-sidebar',
        filledInput: 'filter__option_filled',
        formActivity: 'filter__form_active',
        showAllBrands: 'js-show-all-brands',
        brandsGroup: 'js-brands-group',
        searchCounter: 'js-filter-search-counter',
        selectedParamsCounter: 'js-filter-params-counter',
        expandButton: 'js-filter-expand',
        accordionControl: 'js-filter-sidebar-accordion', 
        openFilterButton: 'js-open-filter',
        filterBackMobile:  'js-filter-back',
        filterCloseMobile: 'js-filter-close',
    };

    constructor(wrapperSelector: string)
    {
        this.wrapper = document.querySelector(wrapperSelector);

        if (this.wrapper === null) {
            return;
        }

        this.delayedCall = new DelayedCall();
        this.tabs        = new Tabs('.js-filter-tab-control');

        this.reload();
        this.initModules();
        this.expandFilledInputs();
        this.showSelectedCount();
    }

    /**
     * Загрузка функционала фильтра после окончания загрузки страницы или после обновления формы при помощи вкладок
     */
    public reload()
    {
        this.form = this.wrapper.querySelector('form.filter__form_active');

        this.brands                = this.form.querySelectorAll('input[name^="manufacturer["]');
        this.selectedBrands        = this.form.querySelector('.filter__selected-brands');
        this.selectAllBrandsButton = this.form.querySelectorAll('.' + this.classes.selectAllBrands);
        this.showAllBrandsButton   = this.form.querySelectorAll('.' + this.classes.showAllBrands);
        this.expandFilterButton    = document.querySelector('.' + this.classes.expandButton);
        this.popularBrands         = this.form.querySelector('.filter__popular-brands');
        this.allBrands             = this.form.querySelector('.filter__all-brands');

        try {
            this.hint      = new PopupController('.js-filter-popup-hint',  'form.filter__form_active .filter__options');
            this.hint.setRemoteUrl('/api/specification_hint/');
            this.hint.init();
        } catch (e) {
            if (!(e instanceof DOMElementNotFoundError)) {
                throw e;
            }
        }
    }

    public init()
    {
        if (this.wrapper === null) {
            return;
        }
        
        this.appendEventListeners();
    }

    protected initModules()
    {
        this.switchSelectAllBrandsButtonState();
        this.initInputValidator();
        this.hideButtonClear();
        this.accordion = new Accordion('.filter__sidebar .' + this.classes.accordionControl);
        this.accordion.init();

        this.styledSelect = new StyledSelect('form.filter__form_active .js-filter-styled-select');
        this.styledSelect.init();

        LazyLoad('form.filter__form_active .ll');
    }

    /**
     * Формы подменятся при переключении вкладок, поэтому будем использовать делегированную обработку.
     * Слушатели будут навешиваться на обертку формы this.wrapper
     */
    protected appendEventListeners()
    {
        // переключение форм вкладками или select-ом на мобильных
        document.querySelectorAll('.js-filter-tab-control').forEach(item => {
            let control = item as HTMLElement;

            item.addEventListener('click', () => {
                this.switchFormTab(control);
            });
        });

        let tabsSwitcher = document.querySelector('.js-filter-switch-tab');
        if (tabsSwitcher !== null) {
            tabsSwitcher.addEventListener('valueselected', e => {
                let evt = e as CustomEvent;
                let control = this.tabs.getControlByTabId('filter-tabs-content-' + evt.detail.value);

                this.switchFormTab(control);
            });
        }

        document.addEventListener('click', e => {
            let target = e.target as HTMLElement;
            if (target.classList.contains('catalog__overlay_active')) {
                document.body.classList.toggle('overflowed');
                this.closeSidebarFilter();
            }
        });

        this.wrapper.addEventListener('click', e => {
            let target = e.target as HTMLElement;

            // клик по "Выбрать все" в списках брендов
            if (target.classList.contains(this.classes.selectAllBrands)) {
                let action = '';

                if (this.getSelectedBrandsCount() > 0) {
                    this.unselectBrands();
                } else {
                    this.selectAllBrands();
                }

                this.switchSelectAllBrandsButtonState();
                this.startPrefilter(target);
                this.showSelectedCount();

                return;
            }

            // открытие подсказки в фильтре
            if (!target.parentElement?.classList.contains('js-filter-popup-hint')) {
                this.hint.hide();
            }

            // сворачивание списка брендов в фильтре
            if (target.classList.contains(this.classes.showAllBrands)) {
                this.popularBrands.classList.toggle('display_none');
                this.allBrands.classList.toggle('display_none');
                this.form.classList.toggle(this.classes.formExtended);
                this.switchShowAllBrandsButtonState();
            }

            // открытие окна фильтрации по конкретной характеристике на мобильных
            if (target.classList.contains('filter__option-label')) {
                if (document.documentElement.clientWidth <= BREAKPOINTS.LG) {
                    let parent = getParentByClass(target, this.classes.option);
                    if (parent) {
                        parent.classList.add(this.classes.option + '_active');
                    }
                }
                this.showFilterResultButton();
            }

            // возврат к списку фильтров на мобильных
            if (target.classList.contains(this.classes.filterBackMobile)) {
                this.accordion.closeAllAccordions();
                let parent = getParentByClass(target, this.classes.option);
                if (parent) {
                    parent.classList.remove(this.classes.option + '_active');
                }
                this.hideFilterResultButton();
            } 

            // закрытие открытого фильтра на мобильных
            if (target.classList.contains(this.classes.filterCloseMobile)) {
                this.accordion.closeAllAccordions();
                let parent = getParentByClass(target, this.classes.option);
                if (parent) {
                    parent.classList.remove(this.classes.option + '_active');
                }
                document.body.classList.toggle('overflowed');
                this.hideFilterResultButton();
                this.closeSidebarFilter();
            }
        });

        this.wrapper.addEventListener('change', (e) => {
            let target = e.target as HTMLElement;

            // изменение значения input-а с информацией о бренде
            if (target.getAttribute('name').search(/^manufacturer\[\d+\]/) !== -1) {
                let target = e.target as HTMLInputElement;

                this.synchronizeBrandInputs(target.name, target.checked);
                this.switchSelectAllBrandsButtonState();

                let visibleTarget = target.parentElement.querySelector('.checkbox__imitation') as HTMLElement;
                if (visibleTarget !== null) {
                    this.startPrefilter(visibleTarget);
                }

                this.showSelectedCount();
            }
        });

        // изменение значения в выпадащем списке
        this.wrapper.addEventListener('valueselected', evt => {
            let e = evt as CustomEvent;
            let selectBox = e.target as HTMLElement;

            this.highlightSelect(selectBox, e.detail.value != '' && e.detail.values.length > 0);
            this.startPrefilter(selectBox);
            this.showSelectedCount();
        });

        this.wrapper.addEventListener('keyup', e => {
            let target = e.target as HTMLElement;

            // изменение значения input
            if (target.classList.contains('filter__input')) {
                this.highlightInput(target as HTMLInputElement);
            }
        });

        if (this.expandFilterButton !== null) {
            this.expandFilterButton.addEventListener('click', () => {
                this.wrapper.classList.toggle(this.classes.formExpanded);
                this.switchExpandFilterButtonState();
                //this.sendAnalytics('Все производители');
            });
        }

        this.wrapper.addEventListener('input', e => {
            let target = e.target as HTMLInputElement;

            // изменение значения input
            if (target.classList.contains('filter__input')) {
                this.highlightInput(target);
                this.startPrefilter(target);
                this.showSelectedCount();
            }
        });

        document.querySelectorAll('.' + this.classes.openFilterButton).forEach(item => {
            let control = item as HTMLElement;

            control.addEventListener('click', () => {
                document.body.classList.toggle('overflowed');
                this.accordion.closeAllAccordions();
                this.closeSidebarFilter();
            });
        });

    }

    protected expandFilledInputs() 
    {
        this.wrapper.querySelectorAll('.' + this.classes.filledInput).forEach(item => {
            let input = item as HTMLElement;

            let parent = getParentByClass(input, this.classes.option);

            if (parent) {
                parent.querySelectorAll('.' + this.classes.accordionControl).forEach(item => {
                    let control = item as HTMLElement;

                    this.accordion.openAccordionAfterLoad(control);
                });
            }
        });
    }

    private hideButtonClear()
    {
        let checked = false;

        this.form.querySelectorAll('input[name^="manufacturer"], input[name^="f["], input[name^="price"]')
            .forEach(node => {
                let input = node as HTMLInputElement;

                switch (input.type) {
                    case 'checkbox':
                        if (input.checked == true) {
                            checked = true;
                        }
                        break;

                    default:
                        if (input.classList.contains('filter__option_filled')) {
                            checked = true;
                        }
                }
            });

        if (!checked) {
            this.form.querySelectorAll('.filter__button-clear').forEach(node => {
                let button = node as HTMLInputElement;
                button.classList.add('display_none');
            });
        }
    }

    protected closeSidebarFilter() 
    {
        let catalogOverlay = document.querySelector<HTMLElement>('.catalog__overlay');
        catalogOverlay.classList.toggle('catalog__overlay_active');
        if (this.wrapper.classList.contains('filter__sidebar_opened')) {
            this.wrapper.classList.remove('filter__sidebar_opened');
        } else {
            this.wrapper.classList.add('filter__sidebar_opened');
        }
    }

    protected getActiveTabTitle(): string
    {
        let title = '';
        
        this.tabs.list().forEach(control => {
            if (control.classList.contains(this.tabs.getClassByToken('active'))) {
                title = control.innerText;
            }
        });

        return title;
    }

    protected getInputByName(name: string): Element
    {
        let result = null;

        this.brands.forEach(item => {
            if (result === null && item.getAttribute('name') === name) {
                result = item;
            }
        });

        return result;
    }

    protected switchFormTab(control: HTMLElement)
    {
        let id = 'filter-tabs-content-' + control.dataset.groupId;
        let form = document.getElementById(id);

        this.form.classList.remove(this.classes.formActivity);

        if (form === null) {
            if (this.isTabLoading) {
                return;
            }

            this.isTabLoading = true;

            let params = new FormData;
            params.append('id', control.dataset.groupId);
            params.append('view', control.dataset.view);

            xhr.post('/catalog/get_filter/', params).then(rsp => {
                let wrapper = document.querySelector('.js-filter-form-wrapper');
                wrapper.insertAdjacentHTML('beforeend', rsp.data);

                this.tabs.switchTab(control);
                this.reload();
                this.initModules();
                this.showSelectedCount();
            }).catch(() => {
                // do nothing
            }).then(() => {
                this.isTabLoading = false;
            });
        } else {
            form.classList.add(this.classes.formActivity);
            this.tabs.switchTab(control);
            this.reload();
            this.showSelectedCount();
        }
    }

    protected startPrefilter(target: Element)
    {
        this.delayedCall.execute(this.getProductsCount, 400, this).then(rsp => {
            this.appendPrefilterCount(rsp['data']['total']);
            this.updateInputPlaceholders(rsp['data']['specifications']);
            this.showFilterResultButton();
        });
    }

    protected appendPrefilterCount(count: string)
    {
        let activeFilterForm = this.getActiveFilterFormId();
        activeFilterForm.querySelectorAll('.' + this.classes.searchCounter).forEach(item => {
            let control = item as HTMLElement;
            control.textContent = '(' + count + ')';
        });
    }

    protected getActiveFilterFormId()
    {
        let activeTabId = '';
        let activeFilterFormId = null;

        this.tabs.list().forEach(control => {
            if (control.classList.contains(this.tabs.getClassByToken('active'))) {
               activeTabId = control.getAttribute('data-tab-id');
            }
        });

        activeFilterFormId = document.getElementById(activeTabId) as HTMLElement;
        if (activeFilterFormId) {
            return activeFilterFormId;
        }
    }

    protected showSelectedCount()
    {
        let counter = document.querySelector('.' + this.classes.selectedParamsCounter);

        if (counter) {
            let count = this.form.querySelectorAll('.' + this.classes.filledInput).length
                + (this.form.querySelectorAll('[name^="manufacturer["]:checked').length > 0 ? 1 : 0);

            counter.innerHTML = count.toString();

            if (count > 0) {
                counter.classList.add('counter__value_visible');
            } else {
                counter.classList.remove('counter__value_visible');
            }
        }
    }

    protected showFilterResultButton()
    {
        let buttonSubmit = this.form.querySelector<HTMLElement>('.filter__button-submit');
        let buttonClear  = this.form.querySelector<HTMLElement>('.filter__button-clear');

        if (buttonSubmit) {
            if (buttonSubmit.classList.contains('filter__button_hidden')) {
                buttonSubmit.classList.remove('filter__button_hidden');
                buttonSubmit.classList.add('filter__button_visible');
            }
        }

        if (buttonClear) {
            if (!buttonClear.classList.contains('filter__button_hidden')) {
                buttonClear.classList.add('filter__button_hidden');
            }
        }
    }

    protected hideFilterResultButton()
    {
        let buttonSubmit = this.form.querySelector<HTMLElement>('.filter__button-submit');
        let buttonClear  = this.form.querySelector<HTMLElement>('.filter__button-clear');

        if (buttonSubmit) {
            if (buttonSubmit.classList.contains('filter__button_visible')) {
                buttonSubmit.classList.remove('filter__button_visible');
                buttonSubmit.classList.add('filter__button_hidden');
            }
        }

        if (buttonClear) {
            if (buttonClear.classList.contains('filter__button_hidden')) {
                buttonClear.classList.remove('filter__button_visible');
            }
        }
    }

    protected updateInputPlaceholders(placeholdersValue)
    {
        let activeTabId = '';
        this.tabs.list().forEach(control => {
            if (control.classList.contains(this.tabs.getClassByToken('active'))) {
               activeTabId = control.getAttribute('data-tab-id');
            }
        });
        let activeTab = document.getElementById(activeTabId) as HTMLElement;

        for (let specificationId in placeholdersValue) {
            let inputFrom = activeTab.querySelector('#option-value-from-' + specificationId) as HTMLInputElement;
            if (inputFrom) {
                inputFrom.placeholder = 'от ' + placeholdersValue[specificationId].min;
            }
            let inputTo = activeTab.querySelector('#option-value-to-' + specificationId) as HTMLInputElement;
            if (inputTo) {
                inputTo.placeholder = 'до ' + placeholdersValue[specificationId].max;
            }
        }
    }

    protected getProductsCount()
    {
        let params = new FormData(this.form);

        this.prefilterCancelToken = axios.CancelToken.source();

        return xhr.get('/catalog/get_search_count_results?' + formDataToQueryString(params), {
            cancelToken: this.prefilterCancelToken.token
        });
    }

    protected initInputValidator()
    {
        this.form.querySelectorAll('.js-filter-numeric-value').forEach(item => {
            new UserInputValidator(item as HTMLElement).numeric();
        });
    }

    protected highlightSelect(box: Element, isHighlightOn: boolean)
    {
        if (isHighlightOn) {
            box.classList.add(this.classes.filledInput);
        } else {
            box.classList.remove(this.classes.filledInput);
        }
    }

    protected highlightInput(input: HTMLInputElement)
    {
        if (input.value === '') {
            input.classList.remove(this.classes.filledInput);
        } else {
            input.classList.add(this.classes.filledInput);
        }
    }

    protected getSelectedBrandsCount()
    {
        let count = 0;
        
        this.brands.forEach(item => {
            let input = item as HTMLInputElement;
            if (input.checked) {
                count++;
            }
        });

        return count;
    }

    protected switchSelectAllBrandsButtonState()
    {
        let count = this.getSelectedBrandsCount();

        this.selectAllBrandsButton.forEach(button => {
            button.innerText = count > 0 ? 'Отменить выбор' : 'Выбрать всё';
        });
    }

    protected switchShowAllBrandsButtonState()
    {
        this.showAllBrandsButton.forEach(button => {
            button.innerText = this.isFormExtended() ? 'Показать популярных' : 'Все производители';
            button.classList.toggle('filter__link_with-icon-opened');
        });
    }


    protected switchExpandFilterButtonState()
    {
        this.expandFilterButton.innerText = this.isFormExpanded() ? 'Свернуть фильтр' : 'Развернуть фильтр';
        this.expandFilterButton.classList.toggle('filter__link_with-icon-opened');
    }

    protected selectAllBrands()
    {
        this.brands.forEach(brand => {
            brand.checked = true;
        });
    }

    protected unselectBrands(name: string = null)
    {
        this.brands.forEach(brand => {
            if (name === null || brand.name === name) {
                brand.checked = false;
            }
        });
    }

    protected synchronizeBrandInputs(name: string, checked: boolean)
    {
        this.brands.forEach(input => {
            if (input.name === name) {
                input.checked = checked;
            }
        });
    }

    protected isFormExtended(): boolean
    {
        return this.form.classList.contains(this.classes.formExtended);
    }

    protected isFormExpanded(): boolean
    {
        return this.wrapper.classList.contains(this.classes.formExpanded);
    }
}
